






































































































import {Component, Vue, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import BtnDefault from '@/components/UI/BtnDefault.vue';
import IArrow from '@/components/icons/IArrow.vue'
import ICheck from '@/components/icons/ICheck.vue'

const workspace = namespace('workspace')
const dialog = namespace('dialog')

@Component({
  components: {
    BtnDefault,
    IArrow,
    ICheck
  }
})
export default class Exhibition extends Vue {
  @workspace.Action('joinUserExhibition') protected joinUserExhibition: any
  @workspace.Action('setExhibitionDirectory') protected setExhibitionDirectory: any
  @workspace.Action('delExhibitionDirectory') protected delExhibitionDirectory: any
  @workspace.Mutation('setCurrentExhibition') protected setCurrentExhibition: any
  @dialog.Mutation('SetFullPlanShow') protected SetFullPlanShow: any
  @dialog.Mutation('SetFullPlanOptions') protected SetFullPlanOptions: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any

  @Prop({type: [Object], default: {}}) exhibition !: any
  @Prop({type: [Array], default: () => []}) folders !: any
  @Prop({type: Boolean, default: false}) isLastColumn !: any
  @Prop({type: Number, default: 0}) folderCount !: any
  @Prop({type: Boolean, default: false}) role !:  any
  @Prop({type: String, default: ''}) workspace !:  any

  showDescription: boolean = false
  isActive: boolean = false
  loading: boolean = false
  openMenu: boolean = false

  mounted() {
    window.addEventListener('click', () => this.openMenu = false);
  }

  getDate() {
    let begin = this.timeConverter(this.exhibition.begin)
    let end = this.timeConverter(this.exhibition.end)
    return begin.slice(-4) == end.slice(-4) ? begin.slice(0, -4) + ' - ' + end : begin + ' - ' + end
  }

  timeConverter(UNIX_timestamp: any) {
    if (UNIX_timestamp == 0) return ''
    const a = new Date(UNIX_timestamp * 1000);
    const months = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'];
    const year = a.getFullYear();
    const month = this.dable(a.getMonth());
    const date = this.dable(a.getDate());
    const rDate = date + ' ' + months[+month] + ' ' + year;

    return rDate;
  }

  dable(num: number) {
    return num < 10 ? '0' + num : num
  }

  addFolder() {
    this.openMenu = false
    this.$emit('addFolder',{exhibitionCode:this.exhibition.code})
  }

  setActive() {
    this.isActive = true
    let elem = this.$refs[this.exhibition.code] as any
    elem.style.backgroundColor = '#' + this.exhibition.color
  }

  removeActive() {
    this.isActive = false
    this.openMenu = false
    let elem = this.$refs[this.exhibition.code] as any
    elem.style.backgroundColor = ''
  }

  async joinExhibition() {
    if(this.workspace == 'personal') {
      this.loading = true
      await this.joinUserExhibition(this.exhibition.code)
      this.enterToExhibition() 
      this.loading = false
    } else if (!this.exhibition.userParticipation || this.exhibition.userParticipation.plan == 'free'){
      this.setCurrentExhibition(this.exhibition.code)
      this.SetFullPlanShow(true)
    }
  }

  enterToExhibition() {
    this.setCurrentExhibition(this.exhibition.code)
    this.$router.push({name: 'Settings', params:{code: this.$route.params.code, showCode: this.exhibition.code}}).catch(() => {})
    this.SetFullDialogShow(false)
  }

  setFolder(folder: any) {
    this.$emit('setFolder',
        {
          folder: folder._id,
          show: this.exhibition.code
        }
    )
  }

  delFolder(folder: any) {
    this.$emit('delFolder',{
      folder: folder._id,
      show: this.exhibition.code
    })
  }

}
